module.exports = __webpack_public_path__ + "img/thirdfeature.ec29e231.svg";